import * as React from 'react';
import styled from 'styled-components';
import * as cookies from 'react-cookies';
import { __, __r } from 'react-i18n';
import { cookiesExpiresDate } from '../../../utilities';

const CookiesWrapper = styled.div`
  z-index: 999999;
  position: fixed;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-size: 1em;
`;
const CookiesBanner = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  padding: 25px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;
const CookiesMessage = styled.div``;

const CookiesMoreText = styled.span<{ showMore: boolean }>`
  display: inline;

  @media (max-width: 768px) {
    display: ${props => (props.showMore ? 'inline' : 'none')};
  }
`;
const CookiesShowMoreButton = styled.a`
  display: none;
  color: #fff;
  cursor: pointer;
  text-decoration: underline;

  @media (max-width: 768px) {
    display: block;
  }
`;
const CookiesAcceptButton = styled.button`
  display: inline-block;
  align-self: center;
  background: rgba(255, 255, 255, 1);
  text-align: center;
  border-radius: 30px;
  max-width: 120px;
  height: 45px;
  width: 100%;
  border: none;
  text-decoration: none;
  margin-left: 25px;
  cursor: pointer;

  @media (max-width: 768px) {
    margin-left: 0;
    margin-top: 20px;
  }
`;
const CookiesLink = styled.a`
  color: #fff !important;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: #fff;
  }
`;
const CookieIcon = styled.div`
  display: flex;
  width: 5rem;
  margin-right: 2rem;

  @media (max-width: 768px) {
    display: none;
  }
`;
const DropdownIcon = styled.div`
  display: inline-block;
  width: 0.7em;
  margin-left: 0.5em;
`;

function CookiesNotif() {
  const [showCookiesBanner, setShowCookiesBanner] = React.useState(true);
  const [showMore, setShowMore] = React.useState(false);

  const fromCookie = cookies.load('cookie_usage');

  React.useEffect(() => {
    if (fromCookie !== 'YES') {
      setShowCookiesBanner(true);
    } else {
      setShowCookiesBanner(false);
    }
  }, [setShowCookiesBanner, fromCookie]);

  const cookiesAgree = () => {
    cookies.save('cookie_usage', 'YES', {
      path: '/',
      expires: cookiesExpiresDate(),
    });
  };

  const closeCookiesBanner = () => {
    setShowCookiesBanner(false);
    cookiesAgree();
  };

  const showMoreCookiesText = () => {
    setShowMore(true);
  };

  return (
    <>
      {showCookiesBanner ? (
        <CookiesWrapper>
          <CookiesBanner>
            <CookiesMessage>
              {__(
                'Nastavením vášho webového prehliadača vyjadrujete súhlas, resp. nesúhlas',
              )}
              <CookiesMoreText showMore={showMore}>
                {' '}
                {__(`s využívaním cookies pri návšteve našej webovej stránky. Súbory
                cookies nám pomáhajú poskytovať kvalitnejšie služby.`)}{' '}
                <CookiesLink
                  href={__r(
                    'routes:ochrana-osobnych-udajov',
                    '/ochrana-osobnych-udajov',
                  )}
                >
                  <b>{__('Viac informácií')}</b>
                </CookiesLink>
                .
              </CookiesMoreText>
              {!showMore ? (
                <CookiesShowMoreButton onClick={showMoreCookiesText}>
                  <b>{__('Zobraziť viac')}</b>
                </CookiesShowMoreButton>
              ) : null}
            </CookiesMessage>
            <CookiesAcceptButton onClick={closeCookiesBanner}>
              {__('OK')}
            </CookiesAcceptButton>
          </CookiesBanner>
        </CookiesWrapper>
      ) : null}
    </>
  );
}

export { CookiesNotif };
